export const state = () => ({
	current_step: 1,
	additional_education: null,
	all_additional_educations: [],
});

export const mutations = {
	setCurrentStep(state: any, payload: any) {
		state.current_step = payload;
	},
	setAdditionalEducation(state: any, payload: any) {
		state.additional_education = payload;
	},
	setAllAdditionalEducations(state: any, payload: any) {
		state.all_additional_educations = payload;
	},
};

export const getters = {
	getCurrentStep: (state: any) => state.current_step,
	getAdditionalEducation: (state: any) => state.additional_education,
	getAllAdditionalEducations: (state: any) => state.all_additional_educations,
};

export const actions = {
	async getAllAdditionalEducations(state: any, payload: any) {
		if (!(state.state.all_additional_educations.length > 0)) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/profile/additional-education')
					.then((res) => {
						state.commit('setAllAdditionalEducations', res.data);
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				resolve(state.state.all_additional_educations);
			});
		}
	},

	async getAdditionalEducation(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/additional-education/' + payload)
				.then((res) => {
					state.commit('setAdditionalEducation', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createAdditionalEducation(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/additional-education', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editAdditionalEducation(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put(
					'/api/profile/additional-education/' + payload.uuid,
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteAdditionalEducation(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/additional-education/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					'/api/profile/additional-education/' +
						payload.uuid +
						'/documents',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateAllAdditionalEducations(state: any, payload: any) {
		state.commit('setAllAdditionalEducations', payload);
	},

	updateAdditionalEducation(state: any, payload: any) {
		state.commit('setAdditionalEducation', payload);
	},

	updateCurrentStep(state: any, payload: any) {
		state.commit('setCurrentStep', payload);
	},
};
